import { Component, OnInit, Compiler, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { RenewalInboxService } from './renewal-inbox.service';
import { environment as ENV } from '../../../environments/environment';
import { AddCoapplicantComponent } from '../add-coapplicant/add-coapplicant.component';
import { AuthService } from 'app/laas/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AddCustomerService } from '../add-customer/add-customer.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminAuthService } from '../admin-auth.service';
import { ApplicantService } from 'app/laas/applicant.service';
import * as moment from 'moment';
import { AdminService } from '../admin.service';
import { LaasComponent } from 'app/laas/laas.component';
import { AdvancedFilterService } from 'app/core/advanced-filter/advanced-filter.service';
// import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
// import { AddCoapplicantComponent} from '../add-coapplicant/add-coapplicant.component'

@Component({
  selector: 'wl-loader-dialog',
  template: `
    <div style="display:flex;flex-direction:column;justify-content:center;align-items:center;">
    <i class="fa fa-spinner fa-pulse fa-2x fa-fw" style="color:#506c84;margin:0 auto;display:block;"></i>
      <p>Loading Data For the First time.. Please Wait..</p>
    </div>
  `
})
export class LoaderDialogConsentComponent1 {
  message: string

  constructor(
    // public dialogRef: MatDialogRef<LoaderDialogComponent>
    public bsModalRef: BsModalRef,
  ) { }
}

@Component({
  selector: 'wl-renewal-inbox',
  templateUrl: './renewal-inbox.component.html',
  styleUrls: ['./renewal-inbox.component.scss'],
  providers: [
    RenewalInboxService,
    AddCustomerService,
    ApplicantService,
    AdminService,
    LaasComponent,
  ],
})
export class RenewalInboxComponent implements OnInit {
  allUsers: Observable<any>;
  loading: boolean;
  search = new UntypedFormControl();
  rocCount: number;
  credCount: number;
  page: number = 1;
  totalPage: number = 1;
  totalCount: number;
  noUserFound: string;
  reportLink: string;
  adminId: any;
  custId: any;
  iscredCount: boolean;
  showOrHide: boolean;
  placeHolder: string;
  searchHolder: string;
  roleId: string;
  role: string;
  limit: number = 10;
  offset: number = 0;

  userName: string;
  display: boolean;
  typeText: string;
  adminForm: UntypedFormGroup;
  type: any;
  bsModalRef: BsModalRef;
  isRetail: boolean;
  makerOnly: boolean = true;
  pageId: any = 1;
  @ViewChild('date1') firstDate: ElementRef;
  @ViewChild('date2') secondDate: ElementRef;
  showSelectedDate: boolean;
  selectedDate: string;
  showFilter1: boolean = false;
  showFilter2: boolean = false;
  showFilter3: boolean = false;
  showPending: boolean = false;
  currentDate: any;
  heading: string;
  showForConsentNo = false;
  userSearchParameter: string;
  subheading1: string;
  subheading2: string;
  maxDate: string;
  selectedStartDate: any;
  selectedEndDate: any;
  dateInMs: number;
  endDateInMs: any;
  showRenewalDataTable: boolean = true;
  filter: string = '';

  constructor(
    private customer: RenewalInboxService,
    private dialog: MatDialog,
    private auth: AuthService,
    private router: Router,
    private jwt: JwtHelperService,
    private snackbar: MatSnackBar,
    private cust: AdminAuthService,
    private fb: UntypedFormBuilder,
    private applicant: ApplicantService,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    // public modalService: NgbModal
    private modalService: BsModalService,
    private laas: LaasComponent,
    private advancedFilterService: AdvancedFilterService
  ) {
    this.adminForm = this.fb.group({
      custId: ['', Validators.required],
      name: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z ]+')])],
      email: [''],
      mobileNo: [''],

      resAdd: [''],
      offAdd: [''],
      resUnitNo: [''],
      offUnitNo: [''],
      employeeName: [''],
      employeeId: [''],
      fromdate: ['', Validators.required],
      // todate: ['', Validators.required]
    });

    this.iscredCount = ENV.creditScoreSetting.credCount;

    this.showOrHide = true;

    this.searchHolder = 'Search Applicant by Name / Customer ID';

    this.display = false;
  }

  onSearchClick(event) {
    this.loading = true;
  }

  onSearch(value: string) {
    this.filter = value;
    if (this.isCoLogin()) {
      return this.applyFilter(this.filter, 0, 1, 1);
    }

    this.page = 1;
    this.pageId = 1;
    this.loading = true;
    this.customer.getUsers(value, this.roleId, 0, 10, this.userSearchParameter).subscribe({
      next: (res) => {
        this.loading = false;

        if (res && res.success) {
          if (res.result && res.result.resultData && res.result.resultData.length === 0) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.noUserFound = null;
          }
          this.allUsers = res.result.resultData ? res.result.resultData : [];
          this.totalCount = res.result.count ? res.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
        } else {
          this.noUserFound = 'Customer data not found';
          this.allUsers = res.result.resultData ? res.result.resultData : [];
          this.totalCount = 0;
          this.totalPage = 0;
        }
      },
      error: (err) => {
        this.totalCount = 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        this.loading = false;
        throw err;
      },
    });
  }

  ngOnInit() {
    this.roleId = this.customer.getRoleId();
    if (this.isCoLogin()) {
      this.showRenewalDataTable = false;
    }

    sessionStorage.removeItem('filterDateRenewalInboxStart');
    sessionStorage.removeItem('filterDateRenewalInboxEnd');
    this.maxDate = this.adminservice.getCurrentMonth();
    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();

    this.currentDate = moment().format('YYYY-MM');
    // const token = sessionStorage.getItem('HicFCyC7V0mJYg3Yw2BBOQ');
    var encrypted = sessionStorage.getItem('ubknknsviubi--131ss');
    console.log('decrypted ' + JSON.stringify(atob(encrypted)));
    // var jwtObj = this.jwt.decodeToken(token)
    // console.log("jwt token " + JSON.stringify(jwtObj));

    this.showFilter1 =
      window.location.href.split('/')[window.location.href.split('/').length - 1] ==
      'renewal-success'
        ? true
        : false;
    // this.showFilter2 =
    //   window.location.href.split('/')[window.location.href.split('/').length - 1] ==
    //   'renewal-processing'
    //     ? true
    //     : false;
    this.showFilter3 =
      window.location.href.split('/')[window.location.href.split('/').length - 1] ==
      'renewal-failure'
        ? true
        : false;
    this.showPending =
      window.location.href.split('/')[window.location.href.split('/').length - 1] ==
      'view-consent-pending'
        ? true
        : false;

    let urlSplit = window.location.href.split('/')[window.location.href.split('/').length - 1];
    if (urlSplit == 'renewal-success') {
      this.heading = 'Success Cases';
      this.userSearchParameter = 'renewal_success';
    }
    //  else if (urlSplit == 'renewal-processing') {
    //   this.heading = 'Branch Processing';
    //   this.showForConsentNo = true;
    //   this.userSearchParameter = 'renewal_processing';
    // } 
    else if (urlSplit == 'renewal-failure') {
      this.heading = 'Failure Box';
      this.showForConsentNo = true;
      this.userSearchParameter = 'renewal_failure';
    } else if (urlSplit == 'view-consent-pending') {
      this.heading = 'Consent Pending';
    }

    if (sessionStorage.getItem('filterDateRenewalInbox')) {
      this.currentDate = moment(
        sessionStorage.getItem('filterDateRenewalInbox'),
        'YYYY-MM-DD'
      ).format('YYYY-MM');
      let selected = this.currentDate;
      var months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      var another = months[+selected.split('-')[1] - 1];
      this.selectedDate = another + ', ' + selected.split('-')[0];
      this.showSelectedDate = true;
    }
    this.roleId = sessionStorage.getItem('getroleId');
    console.log('this.roleId ' + this.roleId);
    // getUsers("", roleId,offset/,limit)
    !this.isCoLogin() && this.getAllUsers('', this.roleId, 0, 10);

    // this.getRocCount();
    // this.applicant = null;
    // sessionStorage.removeItem('wl-applicant-id');
    // sessionStorage.removeItem('wl-custId');

    this.adminId = sessionStorage.getItem('wl-admin-id');
  }

  get_cbs_date(i) {
    if (this.allUsers && this.allUsers[i] && this.allUsers[i]) {
      let sent_to_cbs_date = this.allUsers[i].consent_approval_date
        ? this.allUsers[i].sent_to_cbs_date
        : '';

      if (sent_to_cbs_date) {
        var date = moment(sent_to_cbs_date);
        var dateComponent = date.utc().format('DD-MM-YYYY');
        return dateComponent;
      } else {
        return '';
      }
    }
  }

  onDateRangeSelected(dateRange: any) {
    this.pageId = 1;
    this.page = 1;
    this.offset = 0;
    this.selectedStartDate = dateRange.startDate;
    this.selectedEndDate = dateRange.endDate;
    console.log(dateRange.startDate, dateRange.endDate);
    let date = new Date(this.selectedStartDate);
    this.dateInMs = date.getTime();
    let strStart = this.dateInMs.toString();
    sessionStorage.setItem('filterDateRenewalInboxStart', strStart);
    let storeEnddate = new Date(this.selectedEndDate);
    this.endDateInMs = storeEnddate.getTime();
    let strEnd = this.endDateInMs.toString();
    sessionStorage.setItem('filterDateRenewalInboxEnd', strEnd);
    console.log('check date', this.endDateInMs);
    if (this.dateInMs <= this.endDateInMs) {
      let dateType = 'dateRange';
      this.showSelectedDate = true;
      let startDateConvert = dateRange.startDate.split('-').reverse().join('-');
      let endDateConvert = dateRange.endDate.split('-').reverse().join('-');
      this.selectedDate = startDateConvert + ' - ' + endDateConvert;
      this.customer
        .getUsersFilterDate(
          '',
          this.roleId,
          0,
          10,
          this.dateInMs,
          this.userSearchParameter,
          this.endDateInMs,
          dateType
        )
        .subscribe((res) => {
          console.log(res);
          if (res && res.result && res.result.resultData) {
            this.allUsers = res.result.resultData ? res.result.resultData : '';
            this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
            this.totalPage = Math.ceil(this.totalCount / 10);
          }
        });
    } else {
      this.snackbar.open('Please enter the valid date', 'OK', { duration: 4000 });
    }
  }

  // submitDates() {
  //   if(this.firstDate.nativeElement.value <= this.maxDate && this.firstDate.nativeElement.value >= '2022-01'  ){
  //   this.showSelectedDate = true;
  //   console.log(this.firstDate.nativeElement.value);
  //   let selected = this.firstDate.nativeElement.value;
  //   var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  //   var another = months[+selected.split('-')[1] - 1];
  //   this.selectedDate = another + ', ' + selected.split('-')[0];
  //   console.log(this.firstDate.nativeElement.value);
  //   let filterDate = this.firstDate.nativeElement.value + '-01';
  //   sessionStorage.setItem('filterDateRenewalInbox',filterDate)
  //   let date = new Date(filterDate);
  //   let dateInMs = date.getTime()
  //   this.customer.getUsersFilterDate("", this.roleId, 0, 10, dateInMs, this.userSearchParameter).subscribe(res => {
  //     console.log(res);
  //     if(res && res.result && res.result.resultData){
  //       this.allUsers = res.result.resultData?res.result.resultData:"";
  //       this.totalCount = res && res.result && res.result.count?res.result.count:0;
  //       this.totalPage = Math.ceil(this.totalCount / 10);
  //     }

  //   })
  // }  else{
  //   this.snackbar.open("Please enter the valid date",'OK', {duration:4000})
  // }
  // }

  getAllUsers(input, roleId, offset, limit) {
    this.loading = true;
    // this.page = pageId;

    this.customer.getUsers(input, roleId, offset, limit, this.userSearchParameter).subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        if (res && res.result && res.result.resultData) {
          this.allUsers = res.result.resultData ? res.result.resultData : '';
        }

        // if(res && res.count && res.result.count){
        this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        console.log('this.totalPage ' + this.totalPage);
        // }

        console.log('this.allUsers ' + JSON.stringify(this.allUsers));

        // this.custId = res.result.custId;
        // console.log("custId " +  res.result.custId);
      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
    // this.customer.getUsers(this.search.value, pageId).subscribe(res => {
    //   this.loading = false;
    //   this.allUsers = res.result;
    //   this.totalCount = res.count;
    //   this.totalPage = Math.ceil(this.totalCount / 10);
    //   this.custId = res.result.custId;
    //   console.log("custId " +  res.result.custId);
    // }, err => {
    //   this.loading = false;
    //   this.allUsers = Observable[''];
    //   throw err
    // })
  }

  getAllUsersPage(input, roleId, offset, limit, pageId) {
    if (this.isCoLogin()) {
      return this.applyFilter(input, offset, pageId, pageId);
    }

    this.pageId = pageId;
    console.log(input, roleId, offset, limit, pageId);
    this.loading = true;

    console.log('before page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);
    this.page = pageId;
    this.offset = offset;
    this.limit = limit;

    console.log('after page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);

    this.customer.getUsers(input, roleId, offset, limit, this.userSearchParameter).subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        if (res && res.result && res.result.resultData) {
          this.allUsers = res.result.resultData ? res.result.resultData : '';
          this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          console.log('this.totalPage ' + this.totalPage);
        }
        // this.custId = res.result.custId;
        // console.log("custId " +  res.result.custId);
      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
  }

  getRocCount() {
    this.customer.getRocCounts().subscribe((res) => {
      this.rocCount = res;
    });
  }
  sendToCbs(id, name, accNo, i) {
    this.loading = true;
    console.log(id, name, accNo);
    if (id && name && accNo) {
      this.customer.sendToCbs(id, name, accNo).subscribe((resp) => {
        console.log(resp);
        if (
          resp &&
          resp.respMessage &&
          resp.respMessage.message &&
          resp.respMessage.message == 'success'
        ) {
          this.snackbar.open('Sent to CBS successfully', 'OK', { duration: 3000 });
        }else if(resp && resp.message){
          this.snackbar.open(resp.error?resp.message+", "+resp.error:resp.message,"OK",{duration:3000})
        }
        setTimeout(() => {
          this.loading = false;
          this.ngOnInit();
        }, 3000); 

      });
    }else{
      this.loading = false;
      let text = "Data";
      if(!id){
        text = "Customer ID"
      }else if(!name){
        text = "Profile name"
      }else if(!accNo){
        text = "Account Number"
      }
      this.snackbar.open(`${text} not found`,"OK",{duration:3000})
    }
  }

  View(user) {
    sessionStorage.setItem('wl-applicant-id', user);
    sessionStorage.setItem('applicantId', user);
    // sessionStorage.setItem('lrOpenedFromAdmin','false')
    window.open(ENV.urlSetting.url + 'laas/applications/loan-renewal-form');
  }

  getLogReport() {
    const data = {
      custId: this.adminId,
      type: 1,
    };
    // const message = "data"
  }

  retailCheck(isRetail) {
    console.log('retail...1 ', isRetail);
    // this.customer.isRetail = isRetail;
    if (isRetail == true) {
      sessionStorage.setItem('daGeytsjjdbfckwsdld', 'tDrfsud25362htsjddh');
    } else {
      sessionStorage.setItem('daGeytsjjdbfckwsdld', 'fFywshdssf7d9123dnd');
    }
  }
  openDialog(customerId, type, isRetail) {
    console.log('customer id === > ', customerId);
    console.log('type === > ', type);
    console.log('isRetail === > ', isRetail);
    const data = {
      custId: customerId,
      type: type,
      isRetail: isRetail,
    };

    this.bsModalRef = this.modalService.show(AddCoapplicantComponent, {
      animated: false,
      keyboard: true,
      backdrop: true,
      ignoreBackdropClick: true,
      initialState: data,
    });
    this.bsModalRef.content.onClose.subscribe((result) => {
      console.log('results', result);
    });
  }

  getType(app, coapp, guarantor) {
    if (app) {
      return 'Applicant';
    } else if (coapp) {
      return 'Co-Applicant';
    } else {
      return 'Guarantor';
    }
  }

  sendSms(applicantId) {
    // console.log(applicantId);

    this.applicant.sendSmsManual(applicantId).subscribe((res) => {
      console.log(res, 'Resp');
      res.result == 'sent'
        ? this.snackbar.open('SMS Sent', 'OK', { duration: 3000 })
        : this.snackbar.open('Something went wrong', 'OK', { duration: 3000 });
    });
  }

  closeButtonClick() {
    this.selectedDate = '';
    sessionStorage.removeItem('filterDateRenewalInboxStart');
    sessionStorage.removeItem('filterDateRenewalInboxEnd');
    this.showSelectedDate = false;
    sessionStorage.removeItem('filterDateRenewalInbox');
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }

  checkTheBasis(i) {
    if (this.allUsers && this.allUsers[i] && this.allUsers[i]) {
      let breStatus = this.allUsers[i].bre_status;
      let createdDate = this.allUsers[i].created;
      let isRejected = this.allUsers[i].rejectLoan;

      // let startDate = "2022-05-11T05:15:18.755Z";
      let date1 = new Date();
      let date2 = new Date(createdDate);
      let timeInMilisec = date1.getTime() - date2.getTime();
      let daysBetweenDates = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));

      if (isRejected) {
        return 'Rejected';
      } else if (this.allUsers[i] && this.allUsers[i].reason) {
        let renewal_reasons =  {
          "None": "None",
          "F120": "Failure due to 120 days limit",
          "FBRE": "Failure due to BRE Constraints",
          "F90": "Failure due to 90 days limit"
        }
        if(renewal_reasons[this.allUsers[i].reason]){
          return renewal_reasons[this.allUsers[i].reason]
        }
      } else {
        //bre_failure_reason to be used for bre failure reason
        return 'BRE Failure';
      }
    }
  }

  reject(id) {
    this.applicant.rejectLoan(id).subscribe((resp) => {
      if (resp && resp.success) {
        console.log(resp);
        this.snackbar.open('The Applicant is rejected', 'OK', { duration: 3000 });
      }
    });
  }

  isCoLogin() {
    if (this.roleId === '1') {
      return true;
    }
    return false;
  }

  applyFilter(filter: string = '', offset: number = 0, pageId: number = 1, page: number = 1) {
    this.pageId = pageId;
    this.page = page;
    this.offset = offset;
    this.loading = true;
    this.showRenewalDataTable = true;
    const formData = this.advancedFilterService.getFilterData();
    formData.filter = filter;
    formData.offset = offset;
    formData.searchFilter = this.userSearchParameter;
    try {
      this.customer.getRenewals(formData).subscribe(
        (response) => {
          this.noUserFound = '';
          let resultSet =
            response && response.result && response.result.resultData
              ? response.result.resultData
              : [];
          this.allUsers = resultSet;
          if (!resultSet.length) {
            this.noUserFound = 'Customer data not found';
          } 
          this.totalCount =
            response && response.result && response.result.count ? response.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.loading = false;
        },
        () => {
          this.noUserFound = 'Customer data not found';
          this.loading = false;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      );
    } catch (error) {
      this.snackbar.open(error.message, 'OK', {
        duration: 4000,
      });
      this.loading = false;
      this.totalCount = 0;
      this.totalPage = 0;
    }
  }
}
